import React from 'react';
import PropTypes from 'prop-types';
import HallSpinner from '%paysera_seat_selection_integration/js/seatings/Page/components/SeatingMap/component/HallSpinner';
import SubmissionBlock from './components/SubmissionBlock';
import cartShape from '%paysera_seat_selection_integration/js/seatings/propTypes/cartShape';
import SeatingMap from './components/SeatingMap';
import Cart from './components/Cart';
import DiscountBlock from './components/DiscountBlock';
import SeatsReservationHandlersContext from '%paysera_seat_selection_integration/js/seatings/Page/components/SeatingMap/component/SeatingMapLoader/components/SeatsReservationHandlersContext';

class Page extends React.PureComponent {
    async componentDidMount() {
        const {
            pathParams: { eventSlug },
            event,
            order,
            cart,
            fetchEvent,
            fetchCheckoutData,
        } = this.props;

        if (event === null) {
            fetchEvent({ slug: eventSlug });
        }
        if (order === null || cart === null) {
            fetchCheckoutData();
        }
    }

    render() {
        const {
            event,
            order,
            cart,
            reserveSeating,
            discardSeating,
            handleGeneralAdmissionClick,
            updateReservation,
            initializeHallDefinition,
        } = this.props;
        if (event === null || order === null || cart === null) {
            return null;
        }

        return (
            <React.Fragment>
                <HallSpinner />
                <SeatsReservationHandlersContext.Provider
                    value={{
                        reserveSeating,
                        discardSeating,
                        handleGeneralAdmissionClick,
                        updateReservation,
                        initializeHallDefinition,
                    }}
                >
                    <SeatingMap eventToken={event.token} />
                </SeatsReservationHandlersContext.Provider>
                <Cart />
                <DiscountBlock />
                <SubmissionBlock />
            </React.Fragment>
        );
    }
}

Page.propTypes = {
    pathParams: PropTypes.shape({
        eventSlug: PropTypes.string,
    }).isRequired,
    event: PropTypes.shape({
        token: PropTypes.string,
    }),
    order: PropTypes.shape({
        token: PropTypes.string.isRequired,
    }),
    cart: PropTypes.shape(cartShape),
    fetchEvent: PropTypes.func.isRequired,
    fetchCheckoutData: PropTypes.func.isRequired,
    reserveSeating: PropTypes.func.isRequired,
    discardSeating: PropTypes.func.isRequired,
    handleGeneralAdmissionClick: PropTypes.func.isRequired,
    updateReservation: PropTypes.func.isRequired,
    initializeHallDefinition: PropTypes.func.isRequired,
};

Page.defaultProps = {
    event: null,
    order: null,
    cart: null,
};

export default Page;
